/**
 * The iframe URL for a Vimeo link, or '' when the link is not Vimeo's or has no
 * video id.
 *
 * Lifted out of pages/service-replay/_id.vue, which still uses it, so the AGM
 * briefing normalises its link by the same rule. A player.vimeo.com URL is already
 * an embed and is returned as given (its `?h=` privacy hash and options intact);
 * any other vimeo.com URL has its numeric path segment turned into
 * `https://player.vimeo.com/video/<id>`.
 *
 * @param {string} url
 * @returns {string}
 */
export function getVimeoEmbedUrl(url) {
  if (!url) return '';

  try {
    const parsedUrl = new URL(url);
    const isVimeo = parsedUrl.hostname.includes('vimeo.com');
    if (!isVimeo) return '';

    if (parsedUrl.hostname === 'player.vimeo.com') return url;

    const videoId = parsedUrl.pathname
      .split('/')
      .filter(Boolean)
      .find(segment => /^\d+$/.test(segment));

    return videoId ? `https://player.vimeo.com/video/${videoId}` : '';
  } catch (error) {
    return '';
  }
}
